var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 22.72 11.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #77a395;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.64,.74c.93,.49,1.64,1.18,2.15,2.07,.51,.89,.76,1.91,.76,3.07s-.25,2.17-.76,3.06c-.51,.89-1.23,1.58-2.16,2.07-.93,.49-2.01,.74-3.24,.74H0V0H4.4c1.24,0,2.32,.25,3.25,.74Zm-.9,7.64c.6-.59,.9-1.43,.9-2.51s-.3-1.92-.9-2.53-1.44-.9-2.53-.9h-1.35v6.82h1.35c1.08,0,1.92-.3,2.53-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.81,.74c.92,.49,1.64,1.18,2.15,2.07,.51,.89,.76,1.91,.76,3.07s-.25,2.17-.76,3.06c-.51,.89-1.23,1.58-2.16,2.07-.93,.49-2.01,.74-3.24,.74h-4.4V0h4.4c1.24,0,2.32,.25,3.25,.74Zm-.9,7.64c.6-.59,.9-1.43,.9-2.51s-.3-1.92-.9-2.53c-.6-.6-1.44-.9-2.53-.9h-1.36v6.82h1.36c1.08,0,1.92-.3,2.53-.89Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDd);
export default __webpack_public_path__ + "static/media/dd.2d34ed8c366d53047f455f841642655b.svg";
export { ForwardRef as ReactComponent };